export default __webpack_public_path__ + "static/media/user.15d33117.png";